
import { Component, Inject, Ref, Vue, Watch } from "vue-property-decorator";
import { Container } from "inversify";
import FilterContainer from "../molecules/organization/FilterContainer.vue";
import { ReportListStore } from "../stores/reports/ReportListStore";
import { handleError } from "../../../common/src/utility/errorUtils";
import LoadingOverlay from "../../../common/src/components/LoadingOverlay.vue";
import InlineFormTreeselect from "../../../landing/src/molecules/form/InlineFormTreeselect.vue";
import ReportListItemView from "../molecules/reports/ReportListItem.vue";
import FormInput from "../../../landing/src/molecules/form/FormInput.vue";
import { debounce } from "debounce";
import NoRecords from "../../../common/src/components/NoRecords.vue";
import { ReportFilterStore } from "../stores/reports/ReportFilterStore";

@Component({
    components: {
        FilterContainer,
        LoadingOverlay,
        InlineFormTreeselect,
        FormInput,
        NoRecords,
        ReportListItemView,
    },
})
export default class SectorCompanyReportsView extends Vue {
    @Inject("container") readonly container!: Container;
    readonly listStore: ReportListStore = this.container.get(ReportListStore);
    readonly filterStore: ReportFilterStore = this.container.get(ReportFilterStore);
    @Ref("reportListView")
    readonly reportListViewEle!: HTMLElement;

    mounted() {
        this.listStore.load().catch(handleError);

        this.reportListViewEle.addEventListener("scroll", this.paginateListStore);
    }

    beforeDestroy() {
        this.reportListViewEle.removeEventListener("scroll", this.paginateListStore);

        this.filterStore.resetFilters();
        this.reload();
    }

    paginateListStore() {
        const threshold = 10;

        if (
            this.reportListViewEle.scrollTop + this.reportListViewEle.clientHeight >=
            this.reportListViewEle.scrollHeight - threshold
        ) {
            this.listStore.infiniteScroll();
        }
    }

    reload() {
        this.listStore.reload().catch(handleError);
    }

    @Watch("listStore.query")
    @Watch("filterStore.customTags")
    @Watch("filterStore.serviceTags")
    @Watch("filterStore.productTags")
    @Watch("filterStore.operatingRegimeTags")
    @Watch("filterStore.applicationTags")
    @Watch("filterStore.logicalOperator")
    @Watch("filterStore.afterYear")
    @Watch("filterStore.beforeYear")
    reloadDebounce = debounce(this.reload, 300);
}
